<template>
  
<div>
    <router-view/>
</div>
</template>
<style >
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
  
    
  }
  body{
    /* border: 3px solid red; */
     background-color: #fbfaf8;
     overflow-x: hidden;

    
    
    ;
  }
</style>



